'use strict';

var React = require('react');
//Components
var SectionHeader = require('../Common/SectionHeader.jsx');
var RadioInput = require('../Common/RadioInput.jsx');

var AccountTypeStore = require('../../stores/AccountTypeStore.js');

var Action = require('../../actions/AccountTypeActions');

function getStateFromStores() {
    return {
        productId: AccountTypeStore.getProductId(),
        accountType: AccountTypeStore.getAccountType(),
        accountTypeList: AccountTypeStore.getAccountTypeList(),
        errorList: AccountTypeStore.getErrorList()
    };
}

var AccountType = React.createClass({
    getInitialState: function () {
        return getStateFromStores();
    },

    // Add change listeners to stores
    componentDidMount: function () {
        AccountTypeStore.addChangeListener(this._onChange);
    },

    // Remove change listers from stores
    componentWillUnmount: function () {
        AccountTypeStore.removeChangeListener(this._onChange);
    },

    _onChange: function () {
        this.setState(getStateFromStores());
    },
    handleAccountTypeChange: function (event) {        
        if (this.state.productId === 91 && window.NOA.shouldNavigateToAcquisitionForInvestment && event.target.value === 'I' ) {
            Action.navigateToAcquisition();
            return;
          }
  
        Action.setAccountType(event.target.value);
    },
    render: function () {
        return (
              <div className="form-step">
                <div className="form-sub-section">
                    <SectionHeader sectionName={this.props.content.accountType.sectionHeader}
                                 sectionHelpText={this.props.content.common.sectionHeaderHelp}
                                 NeedHelpInfo={this.props.content.accountType.accountTypeHelp}
                                 focus={this.props.focus} />
                    <div className="container">
                        <div className="form-section">
                            <RadioInput id="accountType"
                                        data={this.state.accountTypeList}
                                        value={this.state.accountType}
                                        label={this.props.content.accountType.accountTypeCopy}
                                        onChange={this.handleAccountTypeChange}
                                        errorList={this.state.errorList} />
                        
                        </div>
                    </div>
                </div>
            </div>
        )
    }
});

module.exports = AccountType;


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./components/AccountType/AccountTypeSection.jsx